module.exports = __webpack_public_path__ + "dist/media/logo--hr.4de6a918.svg";